import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE } from '../config';
import { setStoredAuth } from '../api';
import Button from './ui/Button';
import Card from './ui/Card';
import Input from './ui/Input';

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(180deg, #0a0e27 0%, #1a1f3a 100%)',
    padding: 20,
  },
  title: {
    fontSize: '1.75rem',
    fontWeight: 700,
    background: 'linear-gradient(135deg, #B026FF 0%, #00D4FF 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textAlign: 'center',
    marginBottom: 8,
  },
  subtitle: {
    color: '#B0BEC5',
    fontSize: '0.95rem',
    textAlign: 'center',
    marginBottom: 32,
  },
  error: {
    color: '#ff6b6b',
    fontSize: 14,
    marginTop: 12,
    textAlign: 'center',
  },
};

export default function Login({ onSuccess, initialError }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(initialError || '');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/api/auth/login`, { email, password });
      const { token, user } = res.data;
      setStoredAuth({ token, user });
      onSuccess({ token, user });
    } catch (err) {
      const msg = err.response?.data?.error || 'Falha ao fazer login. Tente novamente.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialError) setError(initialError);
  }, [initialError]);

  return (
    <div style={styles.container}>
      <Card>
        <h1 style={styles.title}>TILTI Dashboard</h1>
        <p style={styles.subtitle}>Entre com seu e-mail e senha</p>
        <form onSubmit={handleSubmit}>
          <Input
            type="email"
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ marginBottom: 16 }}
            autoComplete="email"
            required
          />
          <Input
            type="password"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ marginBottom: 16 }}
            autoComplete="current-password"
            required
          />
          <Button type="submit" fullWidth disabled={loading} style={{ marginTop: 8, padding: 14 }}>
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </form>
        {error && <p style={styles.error}>{error}</p>}
      </Card>
    </div>
  );
}
